/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"informationBlock":"informationBlock_hHErK","title":"title_ZYtfN","content":"content_XP9Wr"};